import { Outlet, RouteObject } from "react-router-dom";

export const internalFeatureFlagRoutes: RouteObject[] = [
  {
    id: "featureFlags",
    path: "feature-flags",
    handle: {
      showSidebar: true,
    },
    lazy: async () => {
      const { InternalFeatureFlagsPage } = await import(
        "features/internal/feature-flags/InternalFeatureFlagsPage"
      );
      return { Component: InternalFeatureFlagsPage };
    },
  },
  {
    id: "featureFlag",
    path: "feature-flags/:featureFlagId",
    element: <Outlet />,
    handle: {
      showSidebar: true,
    },
    children: [
      {
        id: "featureFlagDetails",
        path: "details",
        handle: {
          showSidebar: true,
        },
        lazy: async () => {
          const { InternalFeatureFlagPage } = await import(
            "features/internal/feature-flags/InternalFeatureFlagPage"
          );
          return { Component: InternalFeatureFlagPage };
        },
      },
      {
        id: "featureFlagEdit",
        path: "edit",
        handle: {
          showSidebar: true,
        },
        lazy: async () => {
          const { InternalFeatureFlagEditPage } = await import(
            "features/internal/feature-flags/InternalFeatureFlagEditPage"
          );
          return { Component: InternalFeatureFlagEditPage };
        },
      },
    ],
  },
];
